import { atom } from "jotai";

export const modalTitleAtom = atom("");
export const isModalOpenAtom = atom(false);
export const modalContentAtom = atom(null);
